/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-19 16:04:11
 * @LastEditTime: 2020-12-17 11:39:58
 * @FilePath: \ensurance-front\src\router\modules\integratedQuery.js
 */
const IntegratedQuery = () => import(/* webpackChunkName: 'IntegratedQuery' */ '@/views/integrated-query/integrated-query.vue')
const PersonList = () => import('@/views/integrated-query/personnel-info-list/personnel-info-list.vue')
const PersonEditList = () => import('@/views/integrated-query/personnel-edit-list/personnel-edit-list.vue')
const PersonnelSettlement = () => import('@/views/integrated-query/personnel-Settlement-list/personnel-Settlement-list.vue')
const EnterpriseReimbursementList = () => import('@/views/integrated-query/enterprise-reimbursement-list/enterprise-reimbursement-list.vue')
const DifferenceList = () => import('@/views/integrated-query/difference-list/difference-list.vue')
const PersonApplicationList = () => import('@/views/integrated-query/person-application-list/person-application-list.vue')
const FiveYears = () => import('@/views/integrated-query/person-fiveyears-list/person-fiveyears-list.vue')
const BeforeAge = () => import('@/views/integrated-query/before-age/before-age.vue')
const ReserveCollection = () => import('@/views/integrated-query/reserve-collection/reserve-collection.vue')
const PersonDetail = () => import('@/views/integrated-query/person-info-detail/person-info-detail.vue')
const MonthSummary = () => import('@/views/integrated-query/month-summary/month-summary.vue')

const PersonReturn = () => import('@/views/integrated-query/person-return/person-return.vue')
const PersonStop = () => import('@/views/integrated-query/person-stop/person-stop.vue')
const PersonSuspend = () => import('@/views/integrated-query/person-suspend/person-suspend.vue')
const PersonReissue = () => import('@/views/integrated-query/person-reissue/person-reissue.vue')
const ReportCenter = () => import('@/views/integrated-query/report-center/report-center.vue')
const SettleSuspend = () => import('@/views/integrated-query/settle-suspend/settle-suspend.vue')
export default [
  {
    path: '/integratedQuery',
    name: 'IntegratedQuery',
    component: IntegratedQuery,
    children: [
      {
        path: '/integratedQuery/person_list',
        name: 'PersonList',
        component: PersonList
      },
      {
        path: '/integratedQuery/person_edit_list',
        name: 'PersonEditList',
        component: PersonEditList
      },
      {
        path: '/integratedQuery/person_settlement',
        name: 'PersonnelSettlement',
        component: PersonnelSettlement
      },
      {
        path: '/integratedQuery/firm_reimbursement',
        name: 'EnterpriseReimbursementList',
        component: EnterpriseReimbursementList
      },
      {
        path: '/integratedQuery/difference',
        name: 'DifferenceList',
        component: DifferenceList
      },
      {
        path: '/integratedQuery/month_summary',
        name: 'DifferenceList',
        component: MonthSummary
      },
      {
        path: '/integratedQuery/application',
        name: 'PersonApplicationList',
        component: PersonApplicationList
      },
      {
        path: '/integratedQuery/fiveyears',
        name: 'FiveYears',
        component: FiveYears
      },
      {
        path: '/integratedQuery/age',
        name: 'BeforeAge',
        component: BeforeAge
      },
      {
        path: '/integratedQuery/reserve_collection',
        name: 'ReserveCollection',
        component: ReserveCollection
      },
      {
        path: '/integratedQuery/person_detail',
        name: 'personDetail',
        component: PersonDetail,
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/integratedQuery/person_return',
        name: 'PersonReturn',
        component: PersonReturn
      },
      {
        path: '/integratedQuery/person_stop',
        name: 'PersonStop',
        component: PersonStop
      },
      {
        path: '/integratedQuery/person_suspend',
        name: 'PersonSuspend',
        component: PersonSuspend
      },
      {
        path: '/integratedQuery/person_reissue',
        name: 'PersonReissue',
        component: PersonReissue
      },
      {
        path: '/integratedQuery/report_center',
        name: 'ReportCenter',
        component: ReportCenter
      },
      {
        path: '/integratedQuery/settle_suspend',
        name: 'SettleSuspend',
        component: SettleSuspend
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/integratedQuery.js